import React, { Fragment } from 'react';
import CartEmpty from './components/cart.empty';
import CartTitle from './components/cart.title';
import AvailiableItemTableHeader from './components/cart.availiable-item-table-header';
import UnAvailiableItemTableHeader from './components/cart.unavailiable-item-table-header';
import DialogDeleteItemInCart from './components/cart.dialog-delete-item';
import DialogDeleteUnavailiableItem from './components/cart.dialog-delete-unavailiable-item';
import DialogBeforeConfirmingOrder from './components/cart.dialog-before-confirming-order';
import DialogCartOverStock from '../Dialog/dialog.cart-over-stock';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import * as Actions from '../../store/actions';
import _ from 'lodash';
import classNames from 'classnames';
import { API, CURRENCY, TYPE_PROMOTION, TYPE_USAGE } from '../../constants';
import { formatMoney } from '../../services'
import { Link } from 'react-router-dom';
import './cart.css';
import { debounce } from '../../utils/';
import CartInputDiscountCode from './components/cart.input-discount-code';

class CartMain extends React.Component {
	constructor(props) {
		super(props);
		this.state = {
			cart: this.props.cart,
			promotion: { 
				...this.props.promotion, 
				responcePromotionitem: this.props.promotion?.responcePromotionitem?.map(pro => ({
					...pro, 
					item: pro.item?.map(model => ({ 
						...model, 
						item: model.item?.map(item => ({ 
								...item, 
								qty: 1
							}
						)) 
					}))
				}))
			},
			cartAvailiableItem: [],
			cartUnavailiableItem: [],
			rowFocus: null,
			onChangeQty: 0,
			cartAvailiableItemSelected: [],
			cartUnavailiableItemSelected: [],
			promotionCartSelected: [],
			colorselected:[],
			sizeselected:[],
			showpro:[],
			promotiontotal:0,
			typeItem: props?.buyNow?.status ? (props.buyNow.item.every(item => item.type == "voucher") ? "voucher" : "item") : "item"
		};
	}

	componentDidMount() {
		window.scrollTo(0, 0);
		this.seperateCartItem();
		this.checkPromotiontotal();
		this.checksumPromotion();
	}

	componentDidUpdate(prevProps, prevState) {
		const { UpdatePromotion, cart, buyNow, promotion } = this.props;
		const { cartAvailiableItemSelected } = this.state;
		if (!_.isEqual(prevProps.cart, cart) || !_.isEqual(prevProps.buyNow, buyNow)) {
			this.seperateCartItem();
		}
		if (!_.isEqual(prevProps.promotion, promotion)) {
			this.setState({
				promotion: { 
					...promotion, 
					responcePromotionitem: promotion.responcePromotionitem?.map(pro => ({
						...pro, 
						item: pro.item?.map(model => ({ 
							...model, 
							item: model.item?.map(item => ({ 
									...item, 
									qty: 1
								}
							)) 
						}))
					}))
				},
				promotionCartSelected: []
			}, () => {
				this.setProColorNSizeSelected();
				this.checkPromotiontotal();
			});
		}
		if (!_.isEqual(prevState.cartAvailiableItemSelected, cartAvailiableItemSelected) && !buyNow.status) {
			UpdatePromotion(cartAvailiableItemSelected);
		}
		if (
			!_.isEqual(prevProps.currentLanguage, this.props.currentLanguage) &&
			this.props.isAuthenticated
		) {
			this.props.GetCartData();
		}
	}

	seperateCartItem = () => {
		const { cart, buyNowItem, buyNow, promotion } = this.props;
		const { promotionCartSelected } = this.state;
		if (buyNow.status) {
			this.setState({
				cart: buyNow.item,
				cartAvailiableItem: buyNow.item,
				cartAvailiableItemSelected: buyNow.item.map(item => item.itemId)
			});
			return
		}
		const cartAvailiableItem = _.filter(cart, item => item.itemStock !== 0);
		const cartUnavailiableItem = _.filter(cart, item => item.itemStock === 0);

		let newCartAvailiableItem = []
		let cartAvailiableItemSelected = []
		if (buyNowItem) {
			const isBuyNowItem = _.filter(cartAvailiableItem, item => item.itemId === buyNowItem.itemId);
			const isNotBuyNowItem = _.filter(cartAvailiableItem, item => item.itemId !== buyNowItem.itemId);
			newCartAvailiableItem = [...isBuyNowItem, ...isNotBuyNowItem];
			cartAvailiableItemSelected = [isBuyNowItem[0].itemId]

			this.setState({
				cart,
				cartAvailiableItem: newCartAvailiableItem,
				cartUnavailiableItem,
				cartAvailiableItemSelected
			})
		}
		else {
			cartAvailiableItemSelected = cartAvailiableItem.map(item => item.itemId);
			this.setProColorNSizeSelected();
			this.setState({
				cart,
				cartAvailiableItem,
				cartUnavailiableItem,
				cartAvailiableItemSelected,
				promotionCartSelected: promotion?.responcePromotionitem ? promotion && promotionCartSelected.concat(
					promotion.responcePromotionitem
						.filter(item => !promotionCartSelected.includes(`${item.itemId}-${item.item?.map(model => model.modelId)}`) && item.promotionPrice == 0)
						.map(item => `${item.itemId}-${item.item?.map(model => model.modelId)}`)
				) : null
			});
		}
	};

	setProColorNSizeSelected = () => {
		const { promotion } = this.state;
		let color = []
		let size = []
		if (promotion.responcePromotionitem){
			const getcolor = promotion.responcePromotionitem.map(pro => 
				pro.item?.map(model => { 
					var item = model.item?.filter(item => item.rgbColor); 
					return item.length > 0 && item[0].rgbColor ? model.modelId + item[0].rgbColor: null; 
				}))
				.filter(pro => pro);
			color = _.flattenDeep(getcolor).filter(item => item);
			
			const getsize = promotion.responcePromotionitem.map(pro => 
				pro.item?.map(model => { 
					var item = model.item?.filter(item => item.sizeName); 
					return item.length > 0 ? model.modelId + item[0].sizeName: null; 
				}))
				.filter(pro => pro);
			size = _.flattenDeep(getsize).filter(item => item);
		}
		this.setState({
			colorselected: color,
			sizeselected: size
		});
	}

	handleColorSelect = (data,model) => {
		const { colorselected } = this.state;
		const newcolor = colorselected.filter(item => item.split("#")[0] !== model)
		
		newcolor.push(model+data)
		this.setState({colorselected:newcolor});
	}
	
	handleSizeSelect = (data,model) => {
		const { sizeselected } = this.state;
		const newsize = sizeselected.filter(item => item.slice(0,model.length) !== model)
		newsize.push(model+data)
		this.setState({sizeselected:newsize});
	}
	
	handleQtyChangeType = (data, type) => {
		const { CartOpenDialogItemOverStock, buyNow, OpenDialogDeleteItemInCart } = this.props;
		const { itemStock, qty, itemId } = data;
		const { onChangeQty, rowFocus, typeItem } = this.state;
		let newQty = (itemId != rowFocus ? data.qty : onChangeQty) + (type == '+' ? 1 : -1);
		let newQty1 = this.computeNewQty(qty, newQty, itemStock);
		this.setState({ rowFocus: data.itemId, onChangeQty: newQty1 > itemStock ? itemStock : (newQty1 == 0 ? 1 : newQty1) });
		if ((type == '+' && qty === itemStock) || (typeItem == "voucher" && (this.findAmountInBuyNow() - qty + newQty) > 10)) {
			CartOpenDialogItemOverStock();
			return;
		}
		if (type == '-' && qty === 1) {
			OpenDialogDeleteItemInCart(data, buyNow.status && "buyNow");
			return;
		}
		this.handleDecreaseIncreaseQty(data);
	}
	
	checkPromotiontotal = () => {
		const { promotion } = this.props;
		let total = 0
		if (promotion?.responcePromotionitem){
			const prototal = promotion.responcePromotionitem.map(pro => pro.discountItem?.map(model => {var discount = model.amount*(model.price-model.promotionPrice);return discount})||[0])
			if(prototal.length >= 1){
				total = _.flattenDeep(prototal).reduce((a, b) => a + b)
				this.setState({promotiontotal:total});
			} else {
				this.setState({promotiontotal:0})
			}
		}
	}

	handleQtyChangeTypePromotion = async ({ itemStock, qty, itemId }, type, eQty) => {
		let newQty = type == null ? eQty : qty + (type == '+' ? 1 : -1);
		if (newQty > itemStock) newQty = itemStock;
		else if (newQty < 1) newQty = 1;
		var splitItemId = itemId.split('|');
		newQty = await this.handleChangeQtyPromotion(newQty, splitItemId);
		this.setState({
			onChangeQty: newQty
		});
	};

	handleDecreaseIncreaseQty = debounce(data => {
		const { cartAvailiableItemSelected, onChangeQty } = this.state;
		const { isFetching, UpdateProductInCart, buyNow, UpdateBuyNow } = this.props;

		if (!isFetching) {
			if (buyNow.status) UpdateBuyNow(data, onChangeQty);
			else UpdateProductInCart(data, onChangeQty, cartAvailiableItemSelected);
		}
	}, 200);

	handleQtyFocus = ({ qty, itemId }) => {
		this.setState({ rowFocus: itemId, onChangeQty: qty });
	};

	handleQtyChange = (e, data) => {
		const { itemStock } = data;
		const qty = +e.target.value;
		this.setState({ onChangeQty: qty > itemStock ? itemStock : qty });
	};

	handleQtyBlur = async data => {
		const { onChangeQty, cartAvailiableItemSelected } = this.state;
		const { qty, itemStock } = data;
		const { UpdateProductInCart, buyNow, UpdateBuyNow } = this.props;

		let NewQty = this.computeNewQty(qty, onChangeQty, itemStock);

		if (NewQty !== qty) {
			if (buyNow.status) await UpdateBuyNow(data, NewQty);
			else await UpdateProductInCart(data, NewQty, cartAvailiableItemSelected);
		}
		await this.setState({ rowFocus: null, onChangeQty: 0 });

	};

	computeNewQty = (qty, onChangeQty, itemStock) => {
		const { typeItem } = this.state;
		if (typeItem == "voucher") {
			let amountInBuyNow = this.findAmountInBuyNow();
			return ((amountInBuyNow - qty) + onChangeQty) >= 10 ? 10 - (amountInBuyNow - qty) : onChangeQty;
		}
		return (onChangeQty === '' || onChangeQty <= 0) && itemStock > 0 ? 1 : onChangeQty;
	}

	findAmountInBuyNow = () => {
		const { buyNow } = this.props;
		return _.sumBy(buyNow.item, (item) => item.qty);
	}

	handleQtyBlurTypePromotion = async (itemStock) => {
		const { onChangeQty, rowFocus } = this.state;
		const newQty = (onChangeQty === '' || onChangeQty <= 0) 
			? 1 
			: onChangeQty > itemStock 
				? itemStock
				: onChangeQty;
		var splitItemId = rowFocus.split('|');
		await this.handleChangeQtyPromotion(newQty, splitItemId);
		await this.setState({
			rowFocus: null, 
			onChangeQty: 0,
		});
	}

	handleChangeQtyPromotion = async (newQty, splitItemId) => {
		const { promotion } = this.state;
		var newPromotionCart = promotion.responcePromotionitem;
		do {
			newPromotionCart = promotion.responcePromotionitem?.map(pro => ({
				...pro, 
				item: pro.item?.map(model => ({ 
					...model, 
					item: model.item?.map(item => ({ 
							...item, 
							qty: pro.promotionid == splitItemId[0] && model.modelId == splitItemId[1] && item.itemId == splitItemId[2] 
								? newQty
								: +(item?.qty || 1) 
						}
					)) 
				}))
			}));
			var pro = newPromotionCart.find(pro => pro.promotionid == splitItemId[0]);
			var totalPro = this.handleComputeQtyPromotion(pro);
			newQty = totalPro <= pro.amount ? newQty : pro.amount - (totalPro - newQty);
		} while(totalPro > pro.amount);

		await this.setState({
			promotion: { ...promotion, responcePromotionitem: newPromotionCart }
		});
		return newQty;
	}

	handleItemSelect = (itemId, itemSelected) => {
		const selectedIndex = itemSelected.indexOf(itemId);

		let newSelected = [];

		if (selectedIndex === -1) {
			newSelected = newSelected.concat(itemSelected, itemId);
		} else if (selectedIndex === 0) {
			newSelected = newSelected.concat(itemSelected.slice(1));
		} else if (selectedIndex === itemSelected.length - 1) {
			newSelected = newSelected.concat(itemSelected.slice(0, -1));
		} else if (selectedIndex > 0) {
			newSelected = newSelected.concat(
				itemSelected.slice(0, selectedIndex),
				itemSelected.slice(selectedIndex + 1)
			);
		}
		return newSelected;
	}

	handleAvailiableItemSelectAll = debounce(value => {
		const { cartAvailiableItem } = this.state;
		let itemSelected = value ? cartAvailiableItem.map(item => item.itemId) : []
		this.setState({ cartAvailiableItemSelected: itemSelected });
	}, 200);

	handleAvailiableItemSelect = debounce((event, itemId) => {
		const { cartAvailiableItemSelected } = this.state;
		var newSelected = this.handleItemSelect(itemId, cartAvailiableItemSelected);
		this.setState({ cartAvailiableItemSelected: newSelected });
	}, 200);

	handlePromotionCartSelect = (event, itemId, items, model) => {
		const { promotionCartSelected } = this.state;
		if (items.item?.length == 1 && model?.item.length == 1) this.handleChangeQtyPromotion(items.amount, [items.promotionid, items.item[0].modelId, items.item[0].item[0].itemId]);
		if (model?.item.every(item => item.itemStock == 0)) return;
		const totalQtyPro = this.handleComputeQtyPromotion(items);
		var newSelected = totalQtyPro >= items.amount && promotionCartSelected.filter(item => item === itemId).length == 0
			? promotionCartSelected 
			: this.handleItemSelect(itemId, promotionCartSelected);
		this.setState({ promotionCartSelected: newSelected });
	}

	handleComputeQtyPromotion = (items) => {
		const { promotionCartSelected, colorselected, sizeselected } = this.state;
		return _.reduce(
			items.item, 
			(sp, model) => sp + _.reduce(
				model.item, 
				(sm, item) => sm + (
					promotionCartSelected.includes(`${items.promotionid}-${model.modelId}`) 
					&& (colorselected.includes(`${model.modelId}${item.rgbColor}`) || !item?.rgbColor)
					&& (sizeselected.includes(`${model.modelId}${item.sizeName}`) || !item?.sizeName)
						? +(item?.qty || 1)
						: 0
					), 
				0
			), 
			0
		);
	}

	////duplicate function
	handleUnAvailiableItemSelectAll = event => {
		const { cartUnavailiableItem } = this.state;
		if (event.target.checked) {
			this.setState({ cartUnavailiableItemSelected: cartUnavailiableItem.map(item => item.itemId) });
			return;
		}
		this.setState({ cartUnavailiableItemSelected: [] });
	};

	////duplicate function
	handleUnAvailiableItemSelect = (event, itemId) => {
		const { cartUnavailiableItemSelected } = this.state;
		var newSelected = this.handleItemSelect(itemId, cartUnavailiableItemSelected);
		this.setState({ cartUnavailiableItemSelected: newSelected });
	};

	updateCartAvailiableSelected = (deleteItem) => {
		const { cartAvailiableItemSelected } = this.state;
		const _cartAvailiableItemSelected = _.filter(cartAvailiableItemSelected, itemId => itemId !== deleteItem.itemId);
		this.setState({ cartAvailiableItemSelected: _cartAvailiableItemSelected })
	}

	findCartAvailiableSelected = () => {
		const { cartAvailiableItem, cartAvailiableItemSelected, promotion, promotionCartSelected } = this.state;
		return _.concat(
			_.filter(cartAvailiableItem, item => cartAvailiableItemSelected.includes(item.itemId)),
			_.filter(promotion.responcePromotionitem, item => promotionCartSelected.includes(`${item.promotionid}-${item.procode}`)).map(item => ({ ...item, price: item.promotionPrice }))
		)
	};

	calOrder = () => {
		const NewCartAvailiableItem = this.findCartAvailiableSelected();
		const initialValue = 0;
		const order = NewCartAvailiableItem.reduce((accumulator, currentValue) => {
			return accumulator + currentValue.qty;
		}, initialValue);

		return order;
	};

	calAvailiablePrice = () => {
		const NewCartAvailiableItem = this.findCartAvailiableSelected();
		const initialValue = 0;
		const total = NewCartAvailiableItem.reduce((accumulator, currentValue) => {
			const totalPricePerItem = currentValue.qty * currentValue.price;
			return accumulator + totalPricePerItem;
		}, initialValue);

		return total;
	};

	handleCheckOut = async () => {
		const { cartAvailiableItemSelected, promotionCartSelected, colorselected ,sizeselected ,promotiontotal, promotion } = this.state;
		const { CartOpenDialogBeforeConfirmingOrder, CartCheckOutData, isLoading, CheckItemActive, CartOpenDialogItemOverStock } = this.props;

		let itemActive = await CheckItemActive(cartAvailiableItemSelected)
		if(!itemActive)
		{
			CartOpenDialogItemOverStock();
			this.props.GetCartData();
			this.seperateCartItem();
			return
		}
		if (cartAvailiableItemSelected.length === 0) {
			CartOpenDialogBeforeConfirmingOrder();
		} else if (!isLoading) {
			 CartCheckOutData(cartAvailiableItemSelected, promotionCartSelected,promotion, colorselected ,sizeselected ,promotiontotal);
		}
	};

	checksumPromotion = () => {
		const { promotion, showpro } = this.state;
		for (let i = 0; i < promotion?.responcePromotionitem?.length; i++) {
			showpro.push(true)
		}
		this.setState({ showpro: showpro })
	}

	handleShowpro = (index) => {
		const { showpro } = this.state;
		showpro[index] = !showpro[index]
		this.setState({ showpro: showpro })
	}

	render() {
		const {
			cart,
			cartAvailiableItem,
			cartAvailiableItemSelected,
			rowFocus,
			onChangeQty,
			cartUnavailiableItem,
			cartUnavailiableItemSelected,
			promotion,
			itemSelected,
			promotionCartSelected,
			promotiontotal,
			sizeselected,
			showpro,
			colorselected
		} = this.state;

		const {
			isFetching,
			isLoading,
			dialogStock,
			CartCloseDialogItemOverStock,
			dialogDeleteUnAvailiableItem,
			OpenDialogDeleteItemInCart,
			DeleteUnAvailiableItemInCart,
			OpenDialogDeleteUnAvailiableItem,
			CloseDialogDeleteUnAvailiableItem,
			dialogBeforeConfirmingOrder,
			CartCloseDialogBeforeConfirmingOrder,
			wording,
			buyNow
		} = this.props;

		if ((cart || []).length === 0 && !isFetching) {
			return <CartEmpty />;
		}
		return (
			<>
				<DialogCartOverStock open={dialogStock} closeDialog={CartCloseDialogItemOverStock} />
				<DialogDeleteItemInCart itemSelected={itemSelected} updateCartAvailiableSelected={this.updateCartAvailiableSelected} />
				<DialogDeleteUnavailiableItem
					open={dialogDeleteUnAvailiableItem}
					closeDialog={CloseDialogDeleteUnAvailiableItem}
					actionDelete={DeleteUnAvailiableItemInCart}
				/>
				<DialogBeforeConfirmingOrder
					open={dialogBeforeConfirmingOrder}
					closeDialog={CartCloseDialogBeforeConfirmingOrder}
				/>
				<CartTitle />
				<section className='section-wrap-small shopping-cart'>
					<div className='container relative'>
						{cartAvailiableItem.length > 0 && (
							<div className='row'>
								<div className='col-md-12'>
									<div className='cart_totals'>
										<h2 className='heading relative heading-small uppercase bottom-line style-2 left-align mb-30'>
											{wording.cartPage.avaliableOrder.avaliableOrder}
										</h2>
									</div>
									<div className='table-wrap mb-30'>
										<table className='shop_table cart table'>
											<AvailiableItemTableHeader
												numSelected={cartAvailiableItemSelected.length}
												rowCount={cartAvailiableItem.length}
												onSelectAllClick={this.handleAvailiableItemSelectAll}
												buyNowStatus={buyNow.status}
											/>
											<tbody>
												{cartAvailiableItem.map((item, index) => {
													const isSelected =
														cartAvailiableItemSelected.indexOf(item.itemId) !== -1;
													return (
														<tr
															key={`cart-${item.itemId}-${index}`}
															className='cart_item'>
															<td>
																{
																	!buyNow.status && 
																		<input
																			type='checkbox'
																			className={`input-checkbox-${item.itemId}-${item.itemId}`}
																			checked={isSelected}
																			onClick={event => event.stopPropagation()}
																			onChange={event =>
																				this.handleAvailiableItemSelect(
																					event,
																					item.itemId
																				)
																			}
																		/>
																}
															</td>
															<td className='product-thumbnail'>
																<Link
																	to={`/product/${item.itemName.split(" ").join("-")}`}
																>
																	<img
																		src={`${API.PRODUCT_IMG_URL}${item.cartItemImage}`}
																		alt={item.cartItemImage}
																	/>
																</Link>
															</td>

															<td className='product-name'>
																<Link to={`/${item.type || "product"}/${item.itemName.split(" ").join("-")}`} className="white">
																	{item.itemName}
																</Link>
																<ul>
																	{(item.sizeName && item.sizeName !== 'N') && (
																		<li>{`${wording.productPage.product.size}: ${item.sizeName}`}</li>
																	)}

																	{(item.rgbColor && item.rgbColor !== null) && (
																		<li>
																			<div
																				style={{ display: 'flex' }}
																				className='color-select clearfix'>
																				<span
																					style={{ marginTop: 0, marginRight: 4 }}>
																					{`${wording.productPage.product.color}:`}
																				</span>
																				<ul className='color-swatches clearfix'>
																					<li>
																						<a
																							className='pointer'
																							style={{
																								backgroundColor:
																									item.rgbColor,
																								width: 18,
																								height: 18
																							}}
																						/>
																					</li>
																				</ul>
																			</div>
																		</li>
																	)}

																	{item.itemStock === 0 && (
																		<li style={{ color: '#FF0000' }}>
																			{wording.homePage.newArrivals.outOfStock}
																		</li>
																	)}

																	{item.promotionName && (
																		<li>
																			{`${wording.cartPage.avaliableOrder.promotion}: `}
																			{item.promotionName}
																		</li>
																	)}
																</ul>
															</td>

															<td className='product-price'>
																{item.promotionPrice > 0 && item.promotionPrice < item.price ? (
																	<>
																		<del>
																			<span className='amount white'>{`${CURRENCY.B}${formatMoney(item.price)}`}</span>
																		</del>
																		<span
																			className='amount white pl-10'>
																			{`${CURRENCY.B}${formatMoney(item.promotionPrice)}`}
																		</span>
																	</>
																) : (
																		<span className='amount white'>{`${CURRENCY.B}${formatMoney(item.price)}`}</span>
																	)}
															</td>

															<td className='product-quantity'>
																<div className='quantity buttons_added'>
																	<input
																		type='button'
																		value='-'
																		className='react_minus'
																		onClick={() => this.handleQtyChangeType(item, '-')}
																	/>
																	<input
																		title='Qty'
																		className='input-text qty text'
																		type='number'
																		value={
																			rowFocus === item.itemId
																				? onChangeQty
																				: item.qty
																		}
																		onFocus={() => this.handleQtyFocus(item)}
																		onChange={e => this.handleQtyChange(e, item)}
																		onBlur={() => this.handleQtyBlur(item)}
																	/>
																	<input
																		type='button'
																		value='+'
																		className='react_plus'
																		onClick={() => this.handleQtyChangeType(item, '+')}
																	/>
																</div>
															</td>

															<td className='product-subtotal'>
																<span className='amount' style={{ color: '#fff' }}>
																	{rowFocus === item.itemId
																		? `${CURRENCY.B}${formatMoney(onChangeQty * (
																			item.promotionPrice > 0 && item.promotionPrice < item.price
																				? item.promotionPrice
																				: item.price
																		))}`
																		: `${CURRENCY.B}${formatMoney(item.qty * (
																			item.promotionPrice > 0 && item.promotionPrice < item.price
																				? item.promotionPrice
																				: item.price
																		))}`
																	}
																</span>
															</td>

															<td className='product-remove'>
																<a
																	className='remove pointer'
																	title='Remove this item'
																	onClick={() => OpenDialogDeleteItemInCart(item, buyNow.status && "buyNow")}
																/>
															</td>
														</tr>
													);
												})}
											</tbody>
										</table>
									</div>
								</div>
							</div>
						)}

						{(promotion?.responcePromotionitem?.length > 0 && (colorselected || sizeselected)) && (
						<>
						{promotion?.responcePromotionitem?.some(item => item.item) && (

							<div className='row'>
								<div className='col-md-12'>
									<div className='cart_totals'>
										<h2 className='heading relative heading-small uppercase bottom-line style-2 left-align mb-30'>
											{wording.cartPage.promotionCart.title}
										</h2>
									</div>
									<div className='table-wrap mb-30'>
										<table className='shop_table cart table'>
											<thead>
												<tr className="cart_header">
													<th></th>
													<th className='product-name white' colSpan='2'>
														{wording.cartPage.avaliableOrder.product}
													</th>
													<th className='product-price white'>{wording.cartPage.avaliableOrder.price}</th>
													<th className='product-quantity white'>{wording.cartPage.avaliableOrder.quantity}</th>
													<th colSpan="2" className='product-subtotal white'>{wording.cartPage.avaliableOrder.total}</th>
												</tr>
											</thead>
											<tbody>
												{promotion.responcePromotionitem.map((items, index) => {
													return (
														<Fragment key={index}>
														{items.item && items.item.length > 0 && (
															<>
																<tr className="cart_header">
																	<th className='product-name white' colSpan='3'>
																		{items.name}
																	</th>
																	<th></th>
																	<th className='product-price white'></th>
																	<th className='product-quantity white'></th>
																	<th colSpan="2" className='product-subtotal white' style={{textAlign:'right'}}>
																		<i className="fa fa-chevron-down fa-rotate-0" aria-hidden="true" onClick={() => this.handleShowpro(index)}></i>
																	</th>
																</tr>
															</>
														)}
															{showpro[index] && items.item && items.item.map((model,modelindex) => {
																const isSelected = promotionCartSelected.indexOf(`${items.promotionid}-${model.modelId}`) !== -1;
																var totalAmount = this.handleComputeQtyPromotion(items);
																var remainAmount = items.amount - totalAmount;
																return (
																	<Fragment key={modelindex}>
																		<tr className='cart_item'>
																			<td>
																				<input
																				type='checkbox'
																				className={`input-checkbox-${items.promotionid}-${items.promotionid}`}
																				checked={isSelected}
																				onClick={event => event.stopPropagation()}
																				onChange={event =>
																					this.handlePromotionCartSelect(
																						event,
																						`${items.promotionid}-${model.modelId}`,
																						items,
																						model
																					)
																				}
																				/>
																			</td>
																			<td className='product-thumbnail'>
																				{model.item.map((item,index) => {
																					return (
																						<Fragment key={index}>
																							<Link
																								to={`/product/${model.modelName.split(" ").join("-")}`}
																							>
																								{colorselected.includes(model.modelId+item.rgbColor) && sizeselected.includes(model.modelId+item.sizeName) ? (
																									<img
																										src={`${API.PRODUCT_IMG_URL}${item.cartItemImage}`}
																										alt={item.cartItemImage}
																									/>
																								):(
																									<>
																									{item.rgbColor == null && (
																										<img
																											style={{minHeight:126.67}}
																											src={`${API.PRODUCT_IMG_URL}${model.item[0].cartItemImage}`}
																											alt={model.item[0].cartItemImage}
																										/>
																									)}
																									</>
																								)}
																							</Link>
																						</Fragment>
																					)
																				})}
																			</td>
																			<td className='product-name'>
																				<Link to={`/${items.typePrivilege || "product"}/${model.modelName.split(" ").join("-")}`} className="white">
																					{model.modelName}
																				</Link>
																				<ul>
																					{model.item.map((item,index) => {
																						return (
																						<Fragment key={index}>
																							
																							{items.Name && (
																								<li>
																									{`${wording.cartPage.avaliableOrder.promotion}: `}
																									{items.Name}
																								</li>
																							)}
																						</Fragment>
																						)
																					})}

																					{model.item.length > 0 &&
																					(
																						<>
																							<li>
																								<div
																									style={{ display: 'flex' }}
																									className='color-select clearfix'>
																									<span
																										style={{ marginTop: 0, marginRight: 4,lineHeight:'35px' }}>
																										{`${wording.productPage.product.size}:`}
																									</span>
																									{(model.item[0]?.sizeName != model.item[1]?.sizeName && model.item.length > 1) ? model.item.map((item,index) => (
																										<ul className='size-options clearfix' key={index}>
																											<li>
																													<a 
																														className={classNames('pointer', {
																														selected: sizeselected.includes(model.modelId+item.sizeName)
																														})}
																														onClick={() => this.handleSizeSelect(item.sizeName,model.modelId)}
																														style={{lineHeight:'35px',textAlign:'center'}}
																													>
																														{item.sizeName}
																													</a>
																											</li>
																										</ul>
																									)):(
																										<>
																										{(model.item[0].sizeName == "Free Size" || _.chain(model.item).groupBy("sizeName").map((_, key) => key).value().length == 1) && (
																											<ul>
																												<li>
																												<span style={{lineHeight:'35px'}}>{model.item[0].sizeName}</span>
																												</li>
																											</ul>
																										)}
																										</>
																									)}
																								</div>
																							</li>
																							{model.item[0].rgbColor && (
																							<li>
																								<div
																									style={{ display: 'flex' }}
																									className='color-select clearfix'>
																									<span
																										style={{ marginTop: 0, marginRight: 4 }}>
																										{`${wording.productPage.product.color}:`}
																									</span>
																									<ul className='color-swatches clearfix'>
																										<li key={`btn-color-${modelindex}`}>
																											{(model.item[0]?.rgbColor != model.item[1]?.rgbColor) ? model.item.map((item,index) => (
																												<a
																													className={classNames('pointer', {
																														selected: colorselected.includes(model.modelId+item.rgbColor)
																														})}
																													onClick={() => this.handleColorSelect(item.rgbColor,model.modelId)}
																													style={{
																														backgroundColor:
																														item.rgbColor,
																														width: 18,
																														height: 18,
																														marginRight:'3px'
																													}}
																													key={index}
																												/>
																											)):(
																												<a
																													className={classNames('pointer', {
																														selected: colorselected.includes(model.modelId+model.item[0].rgbColor)
																														})}
																													onClick={() => this.handleColorSelect(model.item[0].rgbColor,model.modelId)}
																													style={{
																														backgroundColor:
																														model.item[0].rgbColor,
																														width: 18,
																														height: 18,
																														marginRight:'3px'
																													}}
																												/>
																											)}
																										</li>
																									</ul>
																								</div>
																							</li>
																							)}
																						</>
																					)}

																					{model.item.map((item,index) => (
																						<Fragment key={index}>
																						{item.itemStock === 0 && (
																							<li style={{ color: '#FF0000' }}>
																								{wording.homePage.newArrivals.outOfStock}
																							</li>
																						)}
																						</Fragment>
																					))}

																				</ul>
																			</td>
																			<td className='product-price'>
																				<del>
																					<span className='amount white'>{`${CURRENCY.B}${formatMoney(model.price)}`}</span>
																				</del>
																				<span
																					className='amount white pl-10'>
																					{`${CURRENCY.B}${formatMoney(model.promotionPrice)}`}
																				</span>
																			</td>
																			<td className='product-quantity'>
																				<div className='quantity buttons_added'>
																					{
																						model.item?.length > 0 && (
																							<>
																								{
																									model.item.filter(item => 
																										items.amount == 1 
																										|| items.item?.length == 1
																										|| model.item?.length == 1
																										|| (
																											isSelected 
																											&& (
																												colorselected.includes(model.modelId+item.rgbColor) 
																												|| !item.rgbColor
																											) 
																											&& sizeselected.includes(model.modelId+item.sizeName)
																										)
																									).slice(0, 1).map((item, index) => {
																										const itemStock = item.itemStock > items.amount ? items.amount : item.itemStock;
																										const itemId = `${items.promotionid}|${model.modelId}|${item.itemId}`;
																										const valueItem = { ...item, itemStock, qty: item.qty || 1, itemId };
																										return item && items.amount > 1 && (items.item?.length != 1 || model.item?.length != 1) && isSelected ? (
																											<Fragment key={index}>
																												<input
																													type='button'
																													value='-'
																													className='react_minus'
																													onClick={() => this.handleQtyChangeTypePromotion(valueItem, '-')}
																												/>
																												<input
																													title='Qty'
																													className='input-text qty text'
																													type='number'
																													value={
																														rowFocus === itemId
																															? onChangeQty
																															: valueItem.qty
																													}
																													onFocus={() => this.handleQtyFocus(valueItem)}
																													onBlur={() => this.handleQtyBlurTypePromotion(itemStock)}
																													onChange={e => this.handleQtyChangeTypePromotion(valueItem, null, e.target.value)}
																												/>
																												<input
																													type='button'
																													value='+'
																													className='react_plus'
																													onClick={() => this.handleQtyChangeTypePromotion(valueItem, '+')}
																												/>
																											</Fragment>
																										) : <Fragment key={index}>{isSelected && remainAmount == 0  ? items.amount : (remainAmount >= itemStock ? itemStock: remainAmount)}</Fragment>
																									})
																								}
																							</>
																						)
																					}
																				</div>
																			</td>
																			<td className='product-subtotal'>
																				<span className='amount' style={{ color: '#fff' }}>
																					{`${CURRENCY.B}${formatMoney(items.amount * model.promotionPrice)}`}
																				</span>
																			</td>
																			<td className='product-remove'></td>
																		</tr>
																	</Fragment>
																)
															})}
														</Fragment>
													);
												})}
											</tbody>
										</table>
									</div>
								</div>
							</div>
						)}
						</>
						)}

						{cartUnavailiableItem.length > 0 && (
							<div className='row'>
								<div className='col-md-12'>
									<div
										className={classNames('cart_totals', {
											'mt-60': cartAvailiableItem.length > 0
										})}>
										<h2 className='heading relative heading-small uppercase bottom-line style-2 left-align mb-30'>
											{`${wording.cartPage.unavaliableOrder.unavaliableOrder}`}
										</h2>
									</div>
									<div className='table-wrap mb-5'>
										<table className='shop_table cart table'>
											<UnAvailiableItemTableHeader
												numSelected={cartUnavailiableItemSelected.length}
												rowCount={cartUnavailiableItem.length}
												onSelectAllClick={this.handleUnAvailiableItemSelectAll}
											/>
											<tbody>
												{cartUnavailiableItem.map((item, index) => {
													const isSelected =
														cartUnavailiableItemSelected.indexOf(item.itemId) !== -1;
													return (
														<tr
															key={`cart-noitem-${item.itemId}-${index}`}
															className='cart_item'>
															<td>
																<input
																	type='checkbox'
																	className={`input-checkbox-${item.itemId}-${item.itemId}`}
																	checked={isSelected}
																	onClick={event => event.stopPropagation()}
																	onChange={event =>
																		this.handleUnAvailiableItemSelect(
																			event,
																			item.itemId
																		)
																	}
																/>
															</td>
															<td className='product-thumbnail'>
																<Link to={`/product/${item.itemName.split(" ").join("-")}`}>
																	<img
																		src={`${API.PRODUCT_IMG_URL}${item.cartItemImage}`}
																		alt={item.cartItemImage}
																	/>
																</Link>
															</td>

															<td className='product-name'>
																<Link to={`/${item.type || "product"}/${item.itemName.split(" ").join("-")}`} className="white">
																	{item.itemName}
																</Link>
																<ul>
																	{(item.sizeName && item.sizeName !== 'N') && (
																		<li>{`${wording.productPage.product.size}: ${item.sizeName}`}</li>
																	)}

																	{(item.rgbColor && item.rgbColor !== null) && (
																		<li>
																			<div
																				style={{ display: 'flex' }}
																				className='color-select clearfix'>
																				<span
																					style={{ marginTop: 0, marginRight: 4 }}>
																					{`${wording.productPage.product.color}:`}
																				</span>
																				<ul className='color-swatches clearfix'>
																					<li>
																						<a
																							className='pointer'
																							style={{ backgroundColor: item.rgbColor, width: 18, height: 18 }}
																						/>
																					</li>
																				</ul>
																			</div>
																		</li>
																	)}

																	{item.itemStock === 0 && (
																		<li style={{ color: '#FF0000' }}>
																			{wording.homePage.newArrivals.outOfStock}
																		</li>
																	)}
																</ul>
															</td>

															<td className='product-price'>
																{item.promotionPrice > 0 ? (
																	<>
																		<del>
																			<span className='amount white'>{`${CURRENCY.B}${formatMoney(item.price)}`}</span>
																		</del>
																		<span
																			className='amount white pl-10'>
																			{`${CURRENCY.B}${formatMoney(item.promotionPrice)}`}
																		</span>
																	</>
																) : (
																		<span className='amount white'>{`${CURRENCY.B}${formatMoney(item.price)}`}</span>
																	)}
															</td>

															<td className='product-quantity'></td>

															<td className='product-subtotal'></td>

															<td className='product-remove'>
																<a
																	className='remove pointer'
																	title='Remove this item'
																	onClick={() => OpenDialogDeleteItemInCart(item, buyNow.status && "buyNow")}
																/>
															</td>
														</tr>
													);
												})}
											</tbody>
										</table>
									</div>
									{cartUnavailiableItemSelected.length > 0 && (
										<div>
											<button
												className='btn btn-md btn-red'
												style={{ width: '100%' }}
												onClick={() =>
													OpenDialogDeleteUnAvailiableItem(cartUnavailiableItemSelected)
												}>
												{wording.cartPage.unavaliableOrder.btnDelUnAvaliableOrder}
											</button>
										</div>
									)}
								</div>
							</div>
						)}

						<div className='row'>
							<div className='col-xs-12 col-xs-offset-0 col-md-6 col-md-offset-6 mt-40'>
								<div className='cart_totals'>
									<h2 className='heading relative heading-small uppercase bottom-line style-2 left-align mb-30'>
										{wording.cartPage.cartTotal.cartTotals}
									</h2>

									<table className='table shop_table'>
										<tbody>
											<tr className='cart-order'>
												<th style={{ color: '#fff' }}>{wording.cartPage.cartTotal.order}</th>
												<td style={{ color: '#fff' }}>
													<span className='amount'>{this.calOrder()}</span>
												</td>
											</tr>

											<CartInputDiscountCode ItemSelected={cartAvailiableItemSelected} promotion={promotion?.responcePromotionitem} />

											{
												promotion?.responcePromotionitem?.some(pro => !!pro.discountItem) && (
													<>
														<tr className='cart-sub-total'>
															<th style={{ color: '#fff' }}>
																{wording.cartPage.cartTotal.subTotal}
															</th>
															<td style={{ color: '#fff' }}>
																<span className='amount'>
																	{`${CURRENCY.B}${formatMoney(this.calAvailiablePrice())}`}
																</span>
															</td>
														</tr>

														<tr className='cart-promotion'>
															<th style={{ color: '#fff' }} colSpan='2'>
																<div className="mb-10">
																	{wording.cartPage.cartTotal.promotion}
																</div>
																{promotion.responcePromotionitem.map((item, index) => (
																	<Fragment key={index}>
																		{(item.discountItem && item.discountItem.length > 0) && (
																			<div>
																				<div>
																					<ul className='cart-promotion-list'>
																						{
																							item.typeOfUsageStr == TYPE_USAGE.ONTOP && item.typePromotion == TYPE_PROMOTION.PercentDiscount
																								? (
																									<li>
																										<div className='flex horizontal-between'>
																											<div>
																												<span>-</span>
																												<span>{item.name}</span>
																											</div>
																											<div className='promotion-price'>
																												{`- ${CURRENCY.B}${formatMoney(_.sumBy(item.discountItem, discount => discount.amount * (discount.price - discount.promotionPrice)))}`}
																											</div>
																										</div>
																									</li>
																								)
																								: item.discountItem
																									.filter(discount => discount.amount != 0)
																									.map((discount, index) => (
																										<li key={index}>
																											<div className='flex horizontal-between'>
																												<div>
																													<span>-</span>
																													{
																														(item.typeOfUsageStr == TYPE_USAGE.ONTOP && item.typePromotion == TYPE_PROMOTION.Price_Off) || discount.name == ""
																															? ""
																															: <span>{discount.name}</span>
																													}
																													<span>{item.name}</span>
																												</div>
																												<div className='promotion-price'>
																													{`- ${CURRENCY.B}${formatMoney(discount.amount * (discount.price - discount.promotionPrice))}`}
																												</div>
																											</div>
																										</li>
																									)
																								)
																						}
																					</ul>
																				</div>
																			</div>
																		)}
																	</Fragment>
																))}
															</th>
														</tr>
													</>
												)
											}

											<tr className='order-total'>
												<th style={{ color: '#fff' }}>
													<strong>{wording.cartPage.cartTotal.total}</strong>
												</th>
												<td style={{ color: '#fff' }}>
													<strong>
														<span className='amount'>
															{`${CURRENCY.B}${formatMoney(this.calAvailiablePrice() - (promotiontotal ? promotiontotal : 0))}`}
														</span>
													</strong>
												</td>
											</tr>

										</tbody>
									</table>

									<div className='actions right'>
										<div className='wc-proceed-to-checkout'>
											<button
												className='btn btn-md btn-color'
												onClick={() => this.handleCheckOut()}>
												{
													isLoading
														? "Loading..."
														: wording.cartPage.cartTotal.proceedToCheckout
												}
											</button>
										</div>
									</div>
								</div>
							</div>
						</div>
					</div>
				</section>
			</>
		);
	}
}

const mapStateToProps = ({ cart, language, login, checkout }) => ({
	isFetching: cart.isFetching,
	isLoading: cart.isLoading,
	cart: cart.data,
	promotion: cart.promotion,
	buyNowItem: cart.buyNowItem,
	dialogStock: cart.dialogStock,
	dialogDeleteUnAvailiableItem: cart.dialogDeleteUnAvailiableItem,
	dialogBeforeConfirmingOrder: cart.dialogBeforeConfirmingOrder,
	checkOutData: checkout.checkOutData,
	wording: language.wording,
	buyNow: cart.buyNow,
	currentLanguage: language.currentLanguage,
	isAuthenticated: login.isAuthenticated
});

const mapDispatchToProps = dispatch => {
	return bindActionCreators(
		{
			OpenDialogDeleteItemInCart: Actions.OpenDialogDeleteItemInCart,
			UpdateProductInCart: Actions.UpdateProductInCart,
			CartOpenDialogItemOverStock: Actions.CartOpenDialogItemOverStock,
			CartCloseDialogItemOverStock: Actions.CartCloseDialogItemOverStock,
			DeleteUnAvailiableItemInCart: Actions.DeleteUnAvailiableItemInCart,
			OpenDialogDeleteUnAvailiableItem: Actions.OpenDialogDeleteUnAvailiableItem,
			CloseDialogDeleteUnAvailiableItem: Actions.CloseDialogDeleteUnAvailiableItem,
			CartOpenDialogBeforeConfirmingOrder: Actions.CartOpenDialogBeforeConfirmingOrder,
			CartCloseDialogBeforeConfirmingOrder: Actions.CartCloseDialogBeforeConfirmingOrder,
			CartCheckOutData: Actions.CartCheckOutData,
			UpdateBuyNow: Actions.UpdateBuyNow,
			UpdatePromotion: Actions.UpdatePromotion,
			GetCartData: Actions.GetCartData,
			CheckItemActive: Actions.CheckItemActive,
			CartOpenDialogItemOverStock: Actions.CartOpenDialogItemOverStock,
		},
		dispatch
	)
};

export default connect(
	mapStateToProps,
	mapDispatchToProps
)(CartMain);
